const translations = {
    addFilesButton: 'Add files',
    aircraftSerialLabel: 'Aircraft serial',
    aircraftSerialPlaceholder: 'Auto-detected from file',
    applicationDateLabel: 'Application date',
    applicationTimezoneLabel: 'Timezone',
    applicatorLabel: 'Applicator',
    applicatorPlaceholder: 'Select an applicator',
    applicatorRequiredError: 'Select an applicator to continue',
    areaUnitAcre: 'Acres',
    areaUnitHectare: 'Hectares',
    areaUnitsLabel: 'Area units',
    chooseDroneMakeMessage: 'Choose a drone make in Details to add files',
    dryspreadLabel: 'Dry spread',
    fileErrorConflict: 'file already uploaded',
    fileErrorInvalidData: 'missing required attributes or has invalid data',
    fileErrorInvalidExtension: 'unsupported file type',
    fileErrorMultiAircraft: 'contains data from multiple aircraft',
    fileErrorNotAutoMode: 'flight is not in Auto mode',
    fileErrorUpload: 'failed to upload',
    noFilesMessage: 'No files added yet',
    removeFileLabel: 'Remove',
    swathWidthLabel: 'Swath width (m)',
    swathWidthPlaceholder: 'Enter swath width',
    swathWidthRequiredError: 'Enter a swath width or check "Use drone default"',
    useDroneDefaultSwathLabel: 'Use drone default swath width'
};

export default translations;
